import React, { useEffect, useState } from "react";
import { makeStyles } from "tss-react/mui";
import { TextField, Grid } from "@mui/material";

const useStyles = makeStyles()((theme) => ({
  backdrop: {
    zIndex: 2,
    color: "white",
  },
  verticalcenter: {
    display: "flex",
    flexDirection: "column",
  },
  descriptionParent: {
    display: "flex",
  },

  descriptionIndex: {
    display: "flex",
    flexDirection: "column",
    justifycontent: "center",
    flexBasis: "3%",
    "@media(max-width: 900px)": {
      flexBasis: "3%",
    },
    "@media(max-width: 600px)": {
      flexBasis: "10%",
    },
    "@media(max-width: 400px)": {
      flexBasis: "15%",
    },
  },
  descriptionDetails: {
    flexBasis: "97%",
    textAlign: "justify",
    "@media(max-width: 900px)": {
      flexBasis: "95%",
    },
    "@media(max-width: 600px)": {
      flexBasis: "90%",
    },
    "@media(max-width: 400p6x)": {
      flexBasis: "85%",
    },
  },
}));

const SubQuestionDetails = (props) => {
  const { classes } = useStyles();
  const question = props.question;
  const subQuestion = props.subQuestion;
  const getAnswerValue = (answer) => (answer && answer[0] ? answer[0].answer : "");
  const [textValue, setTextValue] = useState(getAnswerValue(props.answer));
  const ADDITIONAL_COMMENTS_SUBQUESTION_ID = 38;
  const REJECT_REASON_SUBQUESTION_ID = 93;
  useEffect(() => {
    setTextValue(getAnswerValue(props.answer));
  }, [props.answer]);

  const getRenderBreakpoint = (id) => {
    let subQuestionIdList = [30, 31, 32, 33, 34, 35];
    if (subQuestionIdList.includes(id)) {
      return 6;
    } else {
      return 12;
    }
  };

  const handleTextChange = (event) => {
    setTextValue(event.target.value);
  };

  return (
    <Grid item xs={12} lg={getRenderBreakpoint(subQuestion.subQuestionId)} className={classes.verticalcenter}>
      {/* Render Description Inputs */}
      {question.questionId === subQuestion.questionId && (
        <div className={classes.descriptionParent}>
          <TextField
            name={subQuestion.subQuestionId + ""}
            size="small"
            label={subQuestion.description}
            autoComplete="nope"
            variant="outlined"
            disabled={props.formCompleted}
            fullWidth
            value={textValue}
            onChange={handleTextChange}
            multiline={
              subQuestion.subQuestionId === ADDITIONAL_COMMENTS_SUBQUESTION_ID ||
              subQuestion.subQuestionId === REJECT_REASON_SUBQUESTION_ID
            }
            maxRows={
              subQuestion.subQuestionId === ADDITIONAL_COMMENTS_SUBQUESTION_ID ||
              subQuestion.subQuestionId === REJECT_REASON_SUBQUESTION_ID
                ? 30
                : 1
            }
          />
        </div>
      )}
    </Grid>
  );
};

export default SubQuestionDetails;
